import React, { useRef, useEffect } from "react";
import { DatePicker } from "antd";
import { Dayjs } from "dayjs";

const { RangePicker } = DatePicker;

interface DateTimeRangePickerProps {
  startDate: Dayjs | null;
  setStartDate: (date: Dayjs | null) => void;
  endDate: Dayjs | null;
  setEndDate: (date: Dayjs | null) => void;
}

const DateTimeRangePicker: React.FC<DateTimeRangePickerProps> = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}) => {
  const initialStartDate = useRef(startDate);
  const initialEndDate = useRef(endDate);

  useEffect(() => {
    if (!initialStartDate.current) {
      initialStartDate.current = startDate;
    }
    if (!initialEndDate.current) {
      initialEndDate.current = endDate;
    }
  }, [startDate, endDate]);

  return (
    <div className="time-range" style={{ display: "flex", gap: "10px", flexDirection: "column" }}>
      <label style={{ marginBottom: 4 }}>Job Start & End Time</label>
      <RangePicker
        showTime
        allowClear={false}
        value={[startDate, endDate]}
        onChange={(values) => {
          setStartDate(values ? values[0] : null);
          setEndDate(values ? values[1] : null);
        }}
        format="YYYY-MM-DD HH:mm:ss"
        style={{ width: "100%" }}
        placeholder={["Select Start Date & Time", "Select End Date & Time"]}
        disabledDate={(current) => {
          if (!initialStartDate.current || !initialEndDate.current) return false;
          return (
            current &&
            (current.isBefore(initialStartDate.current, "day") ||
              current.isAfter(initialEndDate.current, "day"))
          );
        }}
        disabledTime={(_, type) => {
          if (!initialStartDate.current || !initialEndDate.current) return {};
          const startHour = initialStartDate.current?.hour() || 0;
          const endHour = initialEndDate.current?.hour() || 23;
          return {
            disabledHours: () =>
              Array.from({ length: 24 }, (_, h) => h).filter(
                (h) =>  h < startHour || h > endHour
              ),
            disabledMinutes: (selectedHour) => {
              const startMinute = initialStartDate.current?.minute() || 0;
              const endMinute = initialEndDate.current?.minute() || 59;
              if (selectedHour === startHour) {
                return Array.from({ length: 60 }, (_, m) => m).filter((m) => m < startMinute);
              }
              if (selectedHour === endHour) {
                return Array.from({ length: 60 }, (_, m) => m).filter((m) => m > endMinute);
              }
              return [];
            },
          };
        }}
      />
    </div>
  );
};

export default DateTimeRangePicker;
